<template>
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <div class="page-header-top-container">
                <div id="taskHeader" class="page-name color-71aa3f">
                    Account Information
                </div>
                <button type="submit" class="btn general-button btn-primary" v-on:click.prevent="backShowCustomer">Back</button>
            </div>
            <div class="admin-page-content">
                <div class="row">
                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                        <b-list-group>
                            <template v-for="(customerData , key) in employeeArr">
                                <b-list-group-item>
                                    <div class="row">
                                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                            <strong>User Name : </strong>
                                        </div>
                                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                            <span class="">{{customerData.username}}</span>
                                        </div>
                                    </div>
                                </b-list-group-item>
                                <b-list-group-item>
                                    <div class="row">
                                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                            <strong>First Name : </strong>
                                        </div>
                                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                            <span class="">{{customerData.first_name}}</span>
                                        </div>
                                    </div>
                                </b-list-group-item>
                                <b-list-group-item>
                                    <div class="row">
                                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                            <strong>Middle Name : </strong>
                                        </div>
                                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                            <span class="">{{customerData.middle_name}}</span>
                                        </div>
                                    </div>
                                </b-list-group-item>
                                <b-list-group-item>
                                    <div class="row">
                                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                            <strong>Last Name : </strong>
                                        </div>
                                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                            <span class="">{{customerData.last_name}}</span>
                                        </div>
                                    </div>
                                </b-list-group-item>
                                <b-list-group-item>
                                    <div class="row">
                                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                            <strong>Title : </strong>
                                        </div>
                                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                            <span class="">{{customerData.title}}</span>
                                        </div>
                                    </div>
                                </b-list-group-item>
                                <b-list-group-item>
                                    <div class="row">
                                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                            <strong>Role : </strong>
                                        </div>
                                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                            <span class="" v-for="(role, index) in customerData.roles" :key="index">
                                                <template v-if="role.system_name === 'crm'">
                                                {{ role.name }}
                                                </template>
                                            </span>
                                        </div>
                                    </div>
                                </b-list-group-item>
                            </template>
                        </b-list-group>
                    </div>
                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                        <b-list-group>
                            <template v-for="(customerData , key) in employeeArr">
                                <b-list-group-item>
                                    <div class="row">
                                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                            <strong>Status : </strong>
                                        </div>
                                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                            <span class="">{{formatString(customerData.is_active === 1 ? 'active' : 'inactive')}}</span>
                                        </div>
                                    </div>
                                </b-list-group-item>
                                <b-list-group-item>
                                    <div class="row">
                                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                            <strong>Time Zone : </strong>
                                        </div>
                                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                            <span class="">{{customerData.timezone_name}}</span>
                                        </div>
                                    </div>
                                </b-list-group-item>
                                <b-list-group-item>
                                    <div class="row">
                                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                            <h4 class="color-23727b">Contact</h4>
                                        </div>
                                    </div>
                                </b-list-group-item>
                                <b-list-group-item>
                                    <div class="row">
                                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                            <strong>Phone : </strong>
                                        </div>
                                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                            <span class="">{{mobilenumber(mobilenumber(customerData.contact_no,3,'-'),7,'-')}}</span>
                                        </div>
                                    </div>
                                </b-list-group-item>
                                <b-list-group-item>
                                    <div class="row">
                                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                            <strong>Email : </strong>
                                        </div>
                                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                            <span class="">{{customerData.email}}</span>
                                        </div>
                                    </div>
                                </b-list-group-item>
                            </template>
                        </b-list-group>
                    </div>
                </div>
            </div>
            <div class="page-header-top-container pt-0">
                <div id="taskHeader" class="page-name color-71aa3f">
                    Change Settings
                </div>
            </div>
            <div class="admin-page-content">
                <div class="forms-container">
                    <div class="row no-margin">
                        <!--<div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                            <form id="changeUser">
                                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 hide">
                                    <div class="alert alert-success emailUpdateSuccess" id="alertSuccess">
                                        <span>Username Updated Successfully.</span>
                                    </div>
                                </div>
                                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 hide">
                                    <div class="alert alert-danger" id="alertError">
                                        <span id="errorMsg" class="error"></span>
                                    </div>
                                </div>
                                <div class="col-12 forms-block">
                                    <div class="col-3 paddingleft0">
                                        <div class="form-label"><strong>Username</strong></div>
                                    </div>
                                    <div class="col-9 paddingleft0">
                                        <input type="text" id="email_primary" name="email_primary" class="form-control"
                                               placeholder="Enter Email" v-model="email_primary" 
                                               v-validate="'required|email'">
                                        <div class="requiredstar">*</div>
                                        <span class="help is-danger" v-if="errors.first('email_primary')" v-show="email_primary != ''"><font color="red">Email Must Be A Valid Email</font></span>
                                        <span class="help is-danger" v-if="errors.has('email_primary')" v-show="email_primary == ''"><font color="red">Email is Required</font></span>
                                    </div>    
                                </div>
                                <div class="pull-left col-12">
                                    <div class="col-12 paddingleft0">
                                        <input id="changeUsernameButton" type="submit" value="Update" class="btn general-button btn-primary" v-on:click.prevent="updateUsername()">
                                    </div>
                                </div>
                            </form>
                        </div>-->
                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 hide">
                                <div class="alert alert-success timezoneupdatesuccess" id="alertSuccess">
                                    <!--<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>-->
                                    <span>Time Zone Updated Successfully</span>
                                </div>
                            </div>
                            <div class="col-12 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label"><strong>Time Zone</strong></div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <v-select id="collector" v-model="timezone_id" @change="ChangedValue" name="timezone_id" label="text" :filterable="false" :options="timeArr" @search="onSearch" v-validate="'required'">
                                        <template slot="no-options">
                                            type to search Time Zones...
                                        </template>
                                        <template slot="option" slot-scope="option">
                                            <div class="d-center">
                                                {{ option.text }}
                                            </div>
                                        </template>
                                        <template slot="selected-option" slot-scope="option">
                                            <div class="selected d-center">
                                                {{ option.text }}
                                            </div>
                                        </template>
                                    </v-select>
                                    <div class="requiredstar">*</div>
                                    <span v-show="errors.has('timezone_id')" class="help is-danger" v-if="errors.has('timezone_id')"><font color="red">Time Zone Required</font></span>
                                </div>    
                            </div>
                            <div class="pull-left col-12">
                                <div class="col-12 paddingleft0">
                                    <input id="addCaseBtn" type="submit" value="Update" class="btn general-button btn-primary" v-on:click.prevent="updateTimeZone()">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="page-header-top-container pt-0">
                <div id="taskHeader" class="page-name color-71aa3f">
                    Email Signature
                </div>
            </div>
            <div class="admin-page-content">
                <div class="forms-container">
                    <div class="row no-margin">
                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 hide">
                            <div class="alert alert-success signatureUpdateSuccess" id="alertSuccess">
                                <span>Signature Saved Successfully.</span>
                            </div>
                        </div>
                        <div class="col-12 forms-block">
                            <div class="col-12 paddingleft0">
                                <input type="checkbox" id="isAddImageLogo" name="addlogo_in_signature">
                                <label for="isAddImageLogo" class="permission-label" id="isAddImageLogolbl">
                                    Add Logo In Signature
                                </label>
                            </div>
                        </div>
                        <div class="col-12 forms-block">
                            <div class="col-1point5 paddingleft0">
                                <div class="form-label"><strong>Signature</strong></div>
                            </div>
                            <div class="col-10point5 paddingleft0">
                                <tinymce :plugins="['advlist autolink lists link image charmap print preview hr anchor pagebreak', 'searchreplace wordcount visualblocks visualchars code fullscreen', 'insertdatetime media nonbreaking save table contextmenu directionality', 'template paste textcolor colorpicker textpattern imagetools toc help emoticons hr codesample' ]" class= "" id="tinymce" ref="signdata" v-model="emp_sign"  name="emp_sign"></tinymce>
                            </div>    
                        </div>
                        <div class="col-12">
                            <div class="col-12 paddingleft0">
                                <button class="btn general-button btn-primary" v-on:click="saveEmpSign" id="save_email_signature">Save</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--<div v-if="disImg == ''">
            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                <div class="card">
                    <div class="header">
                        <h2>
                            Put Your Signature Here:
                        </h2>
                    </div>
    
                    <div class="body">
                        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                            <vueSignature ref="signature" :sigOption="option" :w="'378px'" :h="'82px'"></vueSignature>
                        </div>
                        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                            <span style="color: red">{{errormsg}}</span>
                        </div>
                        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                            <button class="btn general-button btn-success waves-effect pull-left" v-on:click="save">Save</button>
                            <button class="btn general-button btn-success waves-effect pull-left" v-on:click="clear">Clear</button>
                            <button class="btn general-button btn-success waves-effect pull-left" v-on:click="undo">Undo</button>
                            <button class="btn general-button btn-success waves-effect pull-left" v-on:click="cancel" v-if="token">Cancel</button>
                        </div>
                    </div>
                    <div class="clearfix"></div>
                </div>
            </div>
        </div>
        <div  v-else  class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
            <div class="card">
                <div class="header">
                    <h2>
                        Signature
                    </h2>
                </div>
                <div class="body">
                    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                        <img :src="imgpath" style="width: 378px; height: 82px" class="emp-signature" /><br>
                    </div>
                    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                        <button class="btn general-button btn-success waves-effect pull-left" v-on:click="edit">Edit</button>
                    </div>
                </div>
                <div class="clearfix"></div>
            </div>
        </div>-->
        <!--<img src=imgpath>-->
        <app-footer></app-footer>
    </div>
</template>
<script>
    import Vue from 'vue';
    import vueSignature from "vue-signature";
    Vue.use(vueSignature)
    import FrontFooter from '@/components/partials/FrontFooter';
    import SessioMixin from '../mixins/sessionmixin';
    import tinymce from 'vue-tinymce-editor';
    export default {
        name: 'CustomerView',
        components: {
            'app-footer': FrontFooter,
            'tinymce': tinymce,
        },
        mixins: [SessioMixin],
        data() {
            return{
                options: {
                    /*language_url: 'http://example.com/js/langs/fa_IR.js' //This url points to location of persian language file.*/
                },
                isLoggedIn: false,
                employeeArr: [],
                disImg: "",
                empId: 0,
                errormsg: "",
                imgpath: "",
                token: false,
                option: {
                    penColor: "rgb(0, 0, 0)",
                    backgroundColor: "rgb(255,255,255)"
                },
                timezone_id: "",
                email_primary: '',
                timeArr: [],
                emp_sign: "",
                addlogo_in_signature: "",
            }
        },
        beforeMount: function () {
            var app = this;
            var check = window.localStorage.getItem('api_token');

            if (check != null) {
                this.isLoggedIn = true;
            }
        },
        mounted: function () {
            $(".removeActive").removeClass('active');
            $("#menuemployee").addClass('active');
            var self = this;
            if (self.$route.params.id != undefined) {
                self.empId = self.$route.params.id;
            }
            if (localStorage.getItem("menu_small") == '1') {
                self.menuSmall();
            } else {
                self.menuBig();
            }
            self.showLoader();

            //var editor = $("#placeHolder").Editor();
            $(document).ready(function () {
                /*tinymce.init({
                 selector: "textarea#tinymce",
                 theme: "modern",
                 height: 300,
                 plugins: [
                 'advlist autolink lists link image charmap hr anchor pagebreak',
                 'searchreplace wordcount visualblocks visualchars code fullscreen',
                 'insertdatetime nonbreaking save table contextmenu directionality',
                 'emoticons template paste textcolor colorpicker textpattern imagetools'
                 ],
                 toolbar1: 'insertfile undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image',
                 toolbar2: 'forecolor backcolor emoticons',
                 image_advtab: true
                 });*/
                //$("#tinymce").Editor();
            });
            self.loademployee();

        },
        methods: {
            ChangedValue: function (value) {
                //console.log(value);
            },
            onSearch(search, loading) {
                if (search.length > 2) {
                    loading(true);
                    this.loadTimeZone(loading, search, this);
                }
            },
            loadTimeZone(loading, search, vm) {
                var self = this;
                $.ajax({
                    url: process.env.ROOT_API + "/timezonelist",
                    type: "GET",
                    headers: {
                        'Accept': 'application/json',
                        "Access-Control-Allow-Origin": '*',
                        "Authorization": "Bearer " + localStorage.getItem("api_token"),
                        'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                        "Cache-Control": "no-cache"
                    },
                    data: {
                        search: search
                    },
                    dataType: 'json',
                    success: function (data) {
                        loading(false);

                        self.timeArr = data;
                        //console.log(self.timeArr);
                    },
                    error: function (jqXHR, exception) {
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem('user_obj');
                                localStorage.removeItem('api_token');
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                })
            },
            updateTimeZone: function () {
                var self = this;
                var path = window.location.pathname;
                var segments = path.split("/");

                var userObj = localStorage.getItem('user_obj');

                var userJson = JSON.parse(userObj);
                var id = userJson['id'];
//                console.log(segments[2]);

                $.ajax({
                    url: process.env.ROOT_API + "/update/employeesettings/" + id,
                    type: "POST",
                    data: {timezone_id: self.timezone_id.value, id: id},
                    headers: {
                        'Accept': 'application/json',
                        "Access-Control-Allow-Origin": '*',
                        "Authorization": "Bearer " + localStorage.getItem("api_token"),
                        'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                        "Cache-Control": "no-cache"
                    },
                    dataType: 'json',
                    success: function (data) {
                        //console.log(data);
                        $(".timezoneupdatesuccess").parent().removeClass('hide');
                        $(".timezoneupdatesuccess").parent().addClass('show');
                        setTimeout(function () {
                            $('.timezoneupdatesuccess').parent().removeClass('show');
                            $('.timezoneupdatesuccess').parent().addClass('hide');
                        }, 5000);
                        if (data.status == 'success') {
                            self.loadContact();
                            //console.log(data.content);
                        }
                    },
                    error: function (jqXHR, exception) {
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem('user_obj');
                                localStorage.removeItem('api_token');
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });
            },
            updateUsername: function () {
                this.$validator.validate().then(result => {
                    if (result) {
                        var self = this;
                        self.showLoader();
                        $("#changeUsernameButton").val('Updating ...');
                        $("#changeUsernameButton").prop('disabled', true);
                        var fields = $("#changeUser").serializeArray();
                        $.ajax({
                            url: process.env.ROOT_API + "/update/username",
                            type: "POST",
                            data: fields,
                            headers: {
                                'Accept': 'application/json',
                                "Access-Control-Allow-Origin": '*',
                                "Authorization": "Bearer " + localStorage.getItem("api_token"),
                                'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                                "Cache-Control": "no-cache"
                            },
                            dataType: 'json',
                            success: function (data) {
                                self.hideLoader();
                                $("#changeUsernameButton").val('Update');
                                $("#changeUsernameButton").prop('disabled', false);
                                //console.log(data.status);
                                if (data.status == "success") {
                                    self.loademployee();
                                    $(".emailUpdateSuccess").parent().removeClass('hide');
                                    $(".emailUpdateSuccess").parent().addClass('show');
                                    setTimeout(function () {
                                        $('.emailUpdateSuccess').parent().removeClass('show');
                                        $('.emailUpdateSuccess').parent().addClass('hide');
                                    }, 5000);
                                } else {
                                    $("#errorMsg").html(data.message);
                                    $(".alert-danger").parent().removeClass('hide');
                                    $(".alert-danger").parent().toggleClass('show');
                                    setTimeout(function () {
                                        $('.alert-danger').parent().removeClass('show');
                                        $('.alert-danger').parent().addClass('hide');
                                    }, 5000);
                                }
                            },
                            error: function (jqXHR, exception) {
                                $("#changeUsernameButton").val('Update');
                                $("#changeUsernameButton").prop('disabled', false);
                                self.hideLoader();
                                $("#changeUsernameButton").val('Update');
                                $("#changeUsernameButton").prop('disabled', false);
                                $("#errorMsg").html(jqXHR.responseJSON.message);
                                $(".alert-danger").parent().removeClass('hide');
                                $(".alert-danger").parent().addClass('show');
                                setTimeout(function () {
                                    $('.alert-danger').parent().removeClass('show');
                                    $('.alert-danger').parent().addClass('hide');
                                }, 5000);
                            }
                        });
                    }
                });
            },
            loademployee: function () {

                // var path = window.location.pathname;
                // var segments = path.split("/");
                // console.log(segments[3]);
                var self = this;
                var userObj = localStorage.getItem('user_obj');

                var userJson = JSON.parse(userObj);
                var id = userJson['id'];
                $.ajax({
                    url: process.env.ROOT_API + "/getemployee_data?empId=" + id,
                    type: "GET",
                    headers: {
                        'Accept': 'application/json',
                        "Access-Control-Allow-Origin": '*',
                        "Authorization": "Bearer " + localStorage.getItem("api_token"),
                        'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                        "Cache-Control": "no-cache"
                    },
                    // data:{
                    //     empId:self.empId
                    // },
                    dataType: 'json',
                    success: function (data) {
                        self.hideLoader();
                        //console.log(data);
                        self.employeeArr = data.content;
                        self.empId = data.content[0].id;
                        self.email_primary = data.content[0].username;
                        self.imgpath = data.content[0].signature_img;
                        self.disImg = self.imgpath;
                        self.timezone_id = {value: data.content[0].timezone_id, text: data.content[0].timezone_name}
                        self.emp_sign = (data.content[0].email_signature != null) ? data.content[0].email_signature : '';
                        self.addlogo_in_signature = data.content[0].addlogo_in_signature;
                        if (self.addlogo_in_signature == 'yes') {
                            $('#isAddImageLogo').attr("checked", true);
                        } else {
                            $('#isAddImageLogo').attr("checked", false);
                        }
                        /*$("#tinymce").html(self.emp_sign);*/
                        //$("#tinymce").Editor("setText", self.emp_sign);
                        //console.log(self.customerArr);

                    },
                    error: function (jqXHR, exception) {
                        self.hideLoader();
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem('user_obj');
                                localStorage.removeItem('api_token');
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });

            },
            save: function () {
                var _this = this;
                //console.log(_this.$refs.signature._data.sig.points.length);

                if (_this.$refs.signature._data.sig.points.length < 1) {
                    _this.errormsg = "Please put your signature here.";
                    return;
                }
                /*Add Loading Display code here*/
                _this.showLoader();
                var png = _this.$refs.signature.save();
                var jpeg = _this.$refs.signature.save('image/jpeg');
                var svg = _this.$refs.signature.save('image/svg+xml');
                //console.log(png);

                var formData = new FormData();

                formData.append('file', png);
                formData.append('id', _this.empId);

                $.ajax({
                    url:
                            process.env.ROOT_API +
                            "/store_signature",
                    type: "POST",
                    headers: {
                        'Accept': 'application/json',
                        "Access-Control-Allow-Origin": '*',
                        "Authorization": "Bearer " + localStorage.getItem("api_token"),
                        'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                        "Cache-Control": "no-cache"
                    },
                    crossDomain: true,
                    processData: false,
                    contentType: false,
                    data: formData,
                    dataType: "json",
                    success: function (data) {
                        /*Add Loading hide code here*/
                        _this.hideLoader();
                        _this.loademployee();
                        _this.errormsg = "";
                        //console.log(data.content[0]["id"]);
                        if (data.status == "success") {


                        }
                    },
                    error: function (jqXHR, exception) {
                        /*Add Loading hide code here*/
                        _this.hideLoader();
                        if (jqXHR.status == 0) {
                            _this.loading = false;
                            _this.error = "Remote server can not be reachable";
                        } else {
                            _this.error = jqXHR.responseJSON.message;
                            _this.loading = false;
                        }
                    }
                });
            },
            saveEmpSign: function () {

                var self = this;
                var imageInSignature = "no";
                //$('#isAddImageLogo').attr("checked", true);
                if ($('#isAddImageLogo').prop('checked') == true) {
                    imageInSignature = "yes";
                }
                /*var isImage = $("#tinymce").Editor("getText");*/
                /*var value = tinyMCE.activeEditor.getContent();*/
                //var value = $("#tinymce").Editor("getText");
                var formData = new FormData();
                formData.append('is_image', imageInSignature);
                formData.append('file', self.emp_sign);
                formData.append('id', self.empId);
                $("#save_email_signature").html('Saving ...');
                $("#save_email_signature").prop('disabled', true);
                $.ajax({
                    url: process.env.ROOT_API + "/store_empsign",
                    type: "POST",
                    headers: {
                        'Accept': 'application/json',
                        "Access-Control-Allow-Origin": '*',
                        "Authorization": "Bearer " + localStorage.getItem("api_token"),
                        'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                        "Cache-Control": "no-cache"
                    },
                    crossDomain: true,
                    processData: false,
                    contentType: false,
                    data: formData,
                    dataType: "json",
                    success: function (data) {
                        /*Add Loading hide code here*/
                        $("#save_email_signature").html('Save');
                        $("#save_email_signature").prop('disabled', false);
                        self.hideLoader();
                        self.loademployee();
                        self.errormsg = "";
                        //console.log(data.content[0]["id"]);
                        if (data.code == "200") {
                            $(".signatureUpdateSuccess").parent().removeClass('hide');
                            $(".signatureUpdateSuccess").parent().addClass('show');
                            setTimeout(function () {
                                $('.signatureUpdateSuccess').parent().removeClass('show');
                                $('.signatureUpdateSuccess').parent().addClass('hide');
                            }, 5000);
                        }
                    },
                    error: function (jqXHR, exception) {
                        /*Add Loading hide code here*/
                        $("#save_email_signature").html('Save');
                        $("#save_email_signature").prop('disabled', false);
                        self.hideLoader();
                        if (jqXHR.status == 0) {
                            self.loading = false;
                            self.error = "Remote server can not be reachable";
                        } else {
                            self.error = jqXHR.responseJSON.message;
                            self.loading = false;
                        }
                    }
                });
            },
            clear: function () {
                var _this = this;
                _this.$refs.signature.clear();
            },
            undo: function () {
                var _this = this;
                _this.$refs.signature.undo();
            },
            addWaterMark: function () {
                var _this = this;
                _this.$refs.signature.addWaterMark({
                    text: "Velocity Vehicle Group", // watermark text, > default ''
                    font: "20px Arial", // mark font, > default '20px sans-serif'
                    style: 'all', // fillText and strokeText,  'all'/'stroke'/'fill', > default 'fill
                    fillStyle: "red", // fillcolor, > default '#333'
                    strokeStyle: "blue", // strokecolor, > default '#333'
                    x: 100, // fill positionX, > default 20
                    y: 150, // fill positionY, > default 20
                    sx: 50, // stroke positionX, > default 40
                    sy: 50                     // stroke positionY, > default 40
                });
            },
            fromDataURL: function (url) {
                var _this = this;
                _this.$refs.signature.fromDataURL("data:image/png;base64,iVBORw0K...");
            },
            backShowCustomer: function () {
                var self = this;
                window.history.back();
                /*self.$router.push('/listemployee');*/

            },
            edit: function () {
                var self = this;
                self.disImg = "";
                self.token = true;
            },
            cancel: function () {
                var self = this;
                self.disImg = self.imgpath;
                self.token = false;
            },
            formatString(data) {
                if (typeof (data) != 'undefined') {
                    var self = this;
                    var value = data.replace(/_/g, " ");
                    var upp = value.toLowerCase().replace(/\b[a-z]/g, function (letter) {
                        return letter.toUpperCase();
                    });
                    return upp;
                } else {
                    return false;
                }
            },
            mobilenumber(string, position, addstring) {
                if (typeof (string) != 'undefined') {
                    if ($.trim(string) === "" && $.trim(string).length <= 0) {
                        return string;
                    } else {
                        return [string.slice(0, position), addstring, string.slice(position)].join('');
                    }
                } else {
                    return false;
                }
            },
            menuSmall: function () {
                $('.opensidebar').show();
                $('.closesidebar').hide();
                $('.menu').addClass('menusmall');
                $('.sidemenu li a span,.legal').addClass('displaynone');
                $('.sidemenu li a i').addClass('displayicons');
                $('.sidebar').css({width: "70px"});
                $('.content').css({marginLeft: "70px"});
                $("html, body").animate({scrollTop: 0}, 10);
            },
            menuBig: function () {
                $('.opensidebar').hide();
                $('.closesidebar').show();
                $('.menu').removeClass('menusmall');
                $('.sidemenu li a span,.legal').removeClass('displaynone');
                $('.sidemenu li a i').removeClass('displayicons');
                $('.sidebar').css({width: "260px"});
                $('.content').css({marginLeft: "260px"});
                $("html, body").animate({scrollTop: 0}, 10);
            }

        }
    }
</script>



// WEBPACK FOOTER //
// src/components/viewProfile.vue